const declarationStatement = [
  '株式会社MSKは、従業員一人ひとりが心身ともに健康で、',
  '活き活きと働ける職場環境づくりを目指し、',
  '健康経営に積極的に取り組むことを宣言いたします。',
];

const healthActionItems = [
  '定期健康診断の受診率100％の継続および受診勧奨の実施',
  '健診結果に基づく再検査・精密検査の受診徹底',
  '特定保健指導の活用',
  '適切な働き方（過重労働の防止・有休取得推進）の実現',
  '運動習慣の定着支援およびメンタルヘルスケア対策の徹底',
  '受動喫煙防止対策の推進と禁煙支援',
];

const HealthContent = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* 宣言文 */}
        <div className="mb-20">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#5DAA68]/10">
              <i className="ri-heart-pulse-line text-lg text-[#5DAA68]"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              基本方針
            </h4>
          </div>
          <div className="border-t border-[#89B56B]/20"></div>

          <div className="mt-10 bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10">
            <h3 className="text-lg md:text-xl font-bold text-[#89B56B] mb-6 leading-relaxed">
              心身ともに健康で活き活きと働ける職場環境へ
            </h3>
            <div className="space-y-2 mb-8">
              {declarationStatement.map((line, index) => (
                <p
                  key={index}
                  className="text-[13px] md:text-sm text-gray-700 leading-[1.9] pl-4 border-l-2 border-[#89B56B]/20"
                >
                  {line}
                </p>
              ))}
            </div>

            <div className="pt-6 border-t border-[#89B56B]/10 text-right text-xs md:text-sm text-gray-600 space-y-1">
              <p>宣言日：令和8年4月28日</p>
              <p>登録番号：健第 110755 号</p>
              <p className="font-bold text-[#89B56B]">株式会社MSK</p>
              <p className="text-xs text-gray-500">（関東ITソフトウェア健康保険組合）</p>
            </div>
          </div>
        </div>

        {/* 宣言の証（証書の掲載領域） */}
        <div className="mb-20">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#5DAA68]/10">
              <i className="ri-award-line text-lg text-[#5DAA68]"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              健康企業宣言の証（STEP1）
            </h4>
          </div>
          <div className="border-t border-[#89B56B]/20"></div>

          <div className="mt-10 bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10">
            <p className="text-xs md:text-sm text-gray-700 leading-[1.9] mb-6">
              当社は健康保険組合連合会東京連合会より「健康企業宣言 STEP1」の登録を受けています。
            </p>

            <a
              href="/image/declaration-certificate.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="block group"
            >
              <div className="border-2 border-dashed border-[#89B56B] rounded-xl px-6 py-10 md:py-12 flex flex-col items-center gap-6 transition-colors group-hover:border-[#5DAA68] group-hover:bg-[#F8FBF6]/60">
                <span className="inline-flex items-center px-5 py-1.5 rounded-full bg-[#5DAA68] text-white text-xs font-bold tracking-wide">
                  STEP1 登録完了
                </span>

                <div className="w-full max-w-sm bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden">
                  <div className="h-1 bg-[#89B56B]"></div>
                  <div className="px-6 py-8 text-center space-y-2">
                    <p className="text-base md:text-lg font-bold text-gray-800">宣言の証</p>
                    <p className="text-xs text-gray-500">登録番号：健第 110755 号</p>
                    <p className="text-sm font-bold text-[#89B56B] pt-1">株式会社ＭＳＫ</p>
                    <p className="text-xs text-gray-500">関東ITソフトウェア健康保険組合</p>
                  </div>
                </div>
              </div>
            </a>

            <p className="mt-5 text-center text-xs text-[#5DAA68]">
              ※Webサイト上ではクリックでPDF閲覧が可能です
            </p>
          </div>
        </div>

        {/* 重点取組項目 */}
        <div>
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#5DAA68]/10">
              <i className="ri-checkbox-circle-line text-lg text-[#5DAA68]"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              重点取組項目
            </h4>
          </div>
          <div className="border-t border-[#89B56B]/20"></div>

          <div className="mt-10 bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10">
            <ul className="space-y-5">
              {healthActionItems.map((item, index) => (
                <li key={index} className="flex items-start gap-4 group">
                  <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-[#89B56B]/10 text-[#5DAA68] text-xs font-bold mt-0.5 group-hover:bg-[#5DAA68] group-hover:text-white transition-colors">
                    {index + 1}
                  </span>
                  <p className="text-[13px] md:text-sm text-gray-700 leading-[1.9] pt-0.5">{item}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthContent;
